export function formatAddress(
  address = '',
  numberOfCharacters = 4,
  chain?: string,
): string {
  // Auto-detect chain if not provided
  if (!chain) {
    // Solana addresses don't start with 0x and are typically 32-44 characters in Base58
    if (
      !address.startsWith('0x') &&
      address.length > 30 &&
      address.length < 50
    ) {
      chain = 'solana';
    } else {
      chain = 'bnb'; // Default to BNB/Ethereum format
    }
  }

  // For Solana addresses, don't add 0x prefix
  if (chain === 'solana') {
    const first = address.slice(0, numberOfCharacters);
    const last = address.slice(-numberOfCharacters);
    return `${first}...${last}`;
  }

  // For Ethereum/BNB addresses, handle 0x prefix
  const addressWithoutPrefix = address.startsWith('0x')
    ? address.slice(2)
    : address;
  const first = addressWithoutPrefix.slice(0, numberOfCharacters);
  const last = addressWithoutPrefix.slice(-numberOfCharacters);
  return `0x${first}...${last}`;
}
